const translations = {
    delete: 'Delete',
    edit: 'Edit'
};

export default translations;
